export function isInternalEmailDomain(email: string, internalEmailDomains: string[]): boolean {
  if (!email) {
    return false;
  }
  return internalEmailDomains.some((domain: string) => email.split('@')[1] === domain);
}
